import React from 'react'
import * as Displays from 'support/displays'
import VacationRequestDate from 'ui/smartview/VacationRequestDate'
import Decline from 'support/actions/generic/Decline'
import Approve from 'support/actions/generic/Approve'

function VacationRequest ({ children }) {
  return (
    <div className='vacation-request'>
      <div className='flex justify-between items-center'>
        <div className='font-medium text-base truncate'>
          <Displays.Text name='requester.name' />
        </div>
        <div className='flex group space-x-1 ml-2'>
          <Decline />
          <Approve />
        </div>
      </div>
      <div className='text-sm text-gray-500'>
        Anmodet: <Displays.Date name='created_at' />
      </div>
      <div className='text-sm text-gray-500'>
        Status: <Displays.Enum name='status' enum='request_status' />
      </div>
      <div className='text-sm text-gray-600 font-medium mt-1'>
        <VacationRequestDate />
      </div>
    </div>
  )
}

export default VacationRequest
